<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="var(--gray-700)"
        aria-hidden="true"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M18 6L6 18M6 6l12 12"
        />
    </svg>
</template>

<script>
export default {
    name: 'XCloseIcon'
}
</script>